import {
  get, post, update, get2, upload, download
} from './helpers'

export function getAngket(uuid) {
  return get(`/mahasiswa/pertanyaan-angket/jawaban?hasil_sidang_uuid=${uuid}`)
}

export function updateAngket($data) {
  return post(`/mahasiswa/pertanyaan-angket/jawaban`, $data)
}




